import {Injectable, NgModule} from '@angular/core';

/**
 * LocalStoreService. Basic wraper for localStorage
 */

export class LocalStoreService {

    /**
     * Stores Value in localstorage
     * @param key
     * @param value
     */
    storeValue(key: string, value: any): void {
        localStorage.setItem(key, value);
        // storage.set(key, value, callback);
    }

    /**
     * Gets a value from localstorage
     * @param key
     * @returns {any}
     */
    getValue(key: string): any {
        return localStorage.getItem(key);
        // return storage.get(key, callback);
    }

    /**
     * Clears a value from localstorage
     * @param key
     */
    clearValue(key: string): void {
        localStorage.removeItem(key);
    }

    /**
     * Clears all localstorage
     */
    clear(): void {
        localStorage.clear();
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}


export class DotLocalStoreModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  providers: [LocalStoreService]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
